<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div class="top_info_container">
            <v-btn to="/Novo-banco" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon> Registrar Contas </v-btn>
            <v-toolbar-title class="titulo_pagina"> Associação de contas Bancária </v-toolbar-title>
            <v-btn to="/bancos/menu" color="blue" fab small> <v-icon small color="white">arrow_back</v-icon> </v-btn>
        </div>

        <v-card>
            <v-container>
                <v-form ref="form2" v-model="valid2" lazy-validation>
                    <v-row>
                        <v-col md="8">
                            <v-combobox v-model="bancoSelected" :items="bancos" :rules="ruleJustRequired" item-text="nome" item-value="nome" filled background-color="#ffff99" label="Selecione o Banco" small-chips return-object>
                                <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.nome"></v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-avatar color="red" class="headline font-weight-light white--text">
                                        <v-btn @click="EliminarBanco(item)" icon fab><v-icon small
                                                style="color:white;">delete</v-icon></v-btn>
                                    </v-list-item-avatar>
                                </template>
                            </v-combobox>
                        </v-col>
                        <v-col md="12">
                            <v-data-table :headers="headers" :items="contas" :search="search" hide-default-footer>
                                <template v-slot:item.conta="{ item }">
                                    <v-text-field v-model="contas[contas.indexOf(item)].conta" background-color="#ffff99"
                                        :rules="ruleRequired" filled label="Nº Conta"></v-text-field>
                                </template>
                                <template v-slot:item.iban="{ item }">
                                    <v-text-field v-mask="'AO-####-####-####-####-####-#'"
                                        v-model="contas[contas.indexOf(item)].iban" background-color="#ffff99"
                                        :rules="ruleRequiredIban" filled label="Iban"></v-text-field>
                                </template>
                                <template v-slot:item.descricao="{ item }">
                                    <v-text-field v-model="contas[contas.indexOf(item)].descricao"
                                        background-color="#ffff99" filled label="Descrição"></v-text-field>
                                </template>
                                <template v-slot:item.moeda="{ item }">
                                    <v-combobox v-model="contas[contas.indexOf(item)].moeda" :items="moedas"
                                        :search-input.sync="search" hide-selected filled outlined background-color="#ffff99"
                                        item-text="descricao" item-value="descricao" label="Selecione" small-chips
                                        :rules="ruleJustRequired" @click="ListarMoedas()"
                                        @change="SelecionaMoeda(contas.indexOf(item))">
                                    </v-combobox>
                                </template>
                                <template v-slot:item.delete="{ item }">
                                    <v-btn small color="#de143c" fab style="color:white;margin-top:-24px;"
                                        @click="remover(contas.indexOf(item))"><v-icon>delete</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
            <v-card-actions>
                      <v-spacer></v-spacer>
                       <v-btn  color="#08cc0b" @click="AddTabela()" :disabled="!valid2 " fab style="color:white;margin-top:-20px;"><v-icon>add</v-icon></v-btn>
                      <v-btn style="color:white;" :disabled="!valid2" color="green darken-1"   @click="SaveConta()">Guardar</v-btn>
                    </v-card-actions>
        </v-card>


    </div>
</template>

<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
    directives: { mask },
    data: () => ({
        isLoading_: false,
    search: '',
    menuFab: null,
    menuExp: null,
    valid2: true,
    overlay: false,
    contasCadastradas:[],
    produtosDesconto: [],
    bancos: [],
    moedas: [],
    opcaodescontoglobal: null,
    opcaoSelecionada: null,
    descontoFlag: false,
    flagDescontoGlobal: false,
    dataExpiracao: '',
    dataFabrico: '',
    produtoSelecionado: null,
    bancoSelected: null,
    valid: true,
    produtos: [],
    contas: [],
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    editedIndex: -1,
    editedItem: {
      nome: '',
      endereco: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: '',
      sigla:''
    },
    editedItemDefault: {
      nome: '',
      endereco: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: '',
      sigla:''
    },
    tab: null,
    items: [
      { tab: 'Geral', content: 'Tab 1 Content' },
      { tab: 'Conta Bancária', content: 'Tab 2 Content' }
    ],
    headers: [
      { text: 'Nº de Conta', value: 'conta' },
      { text: 'IBAN', value: 'iban' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Moeda', value: 'moeda' },
      { text: 'Eliminar', value: 'delete' }
    ],

   ruleJustRequired: [value => !!value || 'campo obrigatorio'],
    ruleSigla: [value => !!value || 'campo obrigatorio', value => (value || '').length > 2 || 'carácteres insuficientes'],

     ruleRequiredIban: [value => !!value || 'campo obrigatorio',value => (value || '').length  > 2 || 'carácteres insuficientes'],
    ruleRequired: [value => !!value || 'campo obrigatorio',value => (value || '').length > 2 || 'carácteres insuficientes'],

    ruleRequiredSemNumero: [value => !!value || 'campo obrigatorio',value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
          return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
          return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]+([,.][0-9]+)?$/g
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ]
    }),

    computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    },

    instituicao (){
      return ls.get('i_id')
    }

  },

  watch: {
    menuFab (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuExp (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 4) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }

      if (val.length >= 4) { return this.initializeProdutos(val) }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.InitializeBAnco()
    this.ListarMoedas()
    this.InitializeContasBancarias()
  },

  methods: {
    Continuar () {
      if (this.$refs.form.validate()) {
        this.tab = 1
      }
    },

    EliminarBanco (item) {
       Swal.fire({
        title: 'Eliminar?',
        text: "Deseja continuar com a operação ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText:'Cancelar',
        reverseButtons:true
      }).then(async (result) => {
        if (result.isConfirmed) {
            try {
                let bancoAssociado = await axios.post('bancoAssociadoanyAccout',item).then((res)=>res.data)
                if(bancoAssociado.length){
                  Swal.fire('Informação', 'Banco associado a uma conta bancária, impossível eliminar.', 'warning')
                }else{
                    let result  =  await axios.post('eliminarBanco',item).then((res)=>res.data)
                    if(result.affectedRows >=1 ){
                      Swal.fire('Informação', 'Banco eliminado com sucesso.', 'success')
                      this.bancos = []
                      this.Limpar2()
                    }else{
                      Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação.', 'error')
                    }
                }
            } catch (error) {
                   Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação.', 'error')
            }
          
          
        }
      })
    },

    async InitializeContasBancarias() {
      try {
        //   let  payload =""
        this.progresso = true;
        this.contasCadastradas = await axios.get('/conta-bancariaFindAll-escola').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false
      }
    },
    async  InitializeBAnco () {
      try {
        //   let  payload =""
        this.overlay = true
        this.bancos = await axios
          .get('/bancosFindAll')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async ListarMoedas () {
      try {
        //   let  payload =""
        this.moedas = await axios
          .get('/moedaFindAll')
          .then(res => res.data)
        //this.moedas.push({ pkMoeda: -1, descricao: 'Nova Moeda', icone: true })
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async SaveConta () {
      if (this.$refs.form2.validate()) {
        let contaExistente = this.contasCadastradas.filter( c=>c.numeroConta.toLowerCase() === this.contas[0].conta && c.instituicao === this.instituicao && c.iban.toString().toLowerCase() === this.contas[0].iban.toString().toLowerCase() && c.descricao.toString().toLowerCase() === this.contas[0].descricao.toString().toLowerCase() )
        if(contaExistente.length){
           Swal.fire('Informação','Conta Bancária já cadastrada.','info')
        }else{
          this.overlay = true
            let params = {
              banco: this.bancoSelected,
              contas: this.contas,
              autor: this.loggedUserName
            }

          try {
            let msg = await axios.post('/ContaFatInsertOrUpdate', params).then(res => res.data);
            if (msg.affectedRows >= 1) {
              Swal.fire('Sucesso', 'Conta associada ao Banco com sucesso', 'success')
              this.Limpar2()
              this.InitializeContasBancarias()
            }else{
                Swal.fire('Erro', 'Ocorreu um erro durante a operação!', 'error');
            }
          } catch (error) {
            Swal.fire('Erro', 'Ocorreu um erro durante a operação!', 'error');
          }finally{
            this.overlay = false
          }
        }
          
        
      }
    },
    SelecionaMoeda (indice) {
      let moeda = this.contas[indice].moeda
      if (moeda.pkMoeda === -1) {
        this.contas[indice].moeda = null
        this.contas[indice].moeda.descricao = ''
        this.di
      }
    },
    AddTabela () {
      if (this.$refs.form2.validate()) {
        let params =
        {
          conta: '',
          iban: 'AO',
          descricao: '',
          moeda: ''
        }
        this.contas.push(params)
      }
    },

    async  savebanco () {
      if (this.$refs.form.validate()) {


      let bancoExitente = this.bancos.filter( b=>b.nome.toString().toLowerCase() === this.editedItem.nome.toString().toLowerCase() )
      if(bancoExitente.length){
        Swal.fire('Informação','Banco já cadastrado','warning')
      }else{
           this.overlay = true
        let params =
          {
            pkBanco: 0,
            nome: this.editedItem.nome,
            endereco: this.editedItem.endereco,
            telefone: this.editedItem.telefone1,
            email: this.editedItem.email,
            obs: this.editedItem.observacao,
            sigla: this.editedItem.sigla

          }
        try {
        //   let  payload =""
          let msg = await axios
            .post('/BancoFatInsertOrUpdate', params)
            .then(res => res.data)
          console.log(msg)
          if (msg.affectedRows >= 1) {
            this.showAlertSucess('Banco inserido com sucesso')
            this.Limpar()
            this.overlay = false
          }
        } catch (error) {
          this.overlay = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
       
      }
    },

    showAlertSucess (msg) {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = msg
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },
    

     showAlertError (msg) {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:red;'
      this.iconAlert = 'error'
      this.alertType = 'error'
      this.msgAlert = msg
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    remover (indice) {
      this.contas.splice(indice, 1)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    Limpar () {
      this.editedItem = this.editedItemDefault
      this.tab = 0
      this.contas = []
      this.InitializeBAnco()
      this.resetValidation()
    },
    Limpar2 () {
      this.bancoSelected = null
      this.editedItem = this.editedItemDefault
      this.contas = []
      this.resetValidation()
    }
  }
}
</script>